module.exports = __webpack_public_path__ + "img/mkt_purchase.80314be9.svg";